export const REQUEST_ADD_ELIGIBILITY_TRANSACTION =
  'REQUEST_ADD_ELIGIBILITY_TRANSACTION';
export const REQUEST_UPDATE_ELIGIBILITY_TRANSACTION =
  'REQUEST_UPDATE_ELIGIBILITY_TRANSACTION';
export const REQUEST_ADD_TRANSACTION = 'REQUEST_ADD_TRANSACTION';
export const REQUEST_GET_TRANSACTION = 'REQUEST_GET_TRANSACTION';
export const REQUEST_SET_TRANSACTION = 'REQUEST_SET_TRANSACTION';
export const REQUEST_UPDATE_TRANSACTION = 'REQUEST_UPDATE_TRANSACTION';
export const REQUEST_ADD_CONTACT_TRANSACTION =
  'REQUEST_ADD_CONTACT_TRANSACTION';
export const REQUEST_GET_CONTACT_TRANSACTION =
  'REQUEST_GET_CONTACT_TRANSACTION';
export const REQUEST_SET_CONTACT_TRANSACTION =
  'REQUEST_SET_CONTACT_TRANSACTION';
export const REQUEST_UPDATE_CONTACT_TRANSACTION =
  'REQUEST_UPDATE_CONTACT_TRANSACTION';
export const RESET_STORE_TRANSACTION = 'RESET_STORE_TRANSACTION';
export const REQUEST_GET_MISSION_TRANSACTION =
  'REQUEST_GET_MISSION_TRANSACTION';
export const REQUEST_SET_MISSION_TRANSACTION =
  'REQUEST_SET_MISSION_TRANSACTION';
export const REQUEST_GET_MISSION_VICTIM_EXPERTISE =
  'REQUEST_GET_MISSION_VICTIM_EXPERTISE';
export const REQUEST_SET_MISSION_VICTIM_EXPERTISE =
  'REQUEST_SET_MISSION_VICTIM_EXPERTISE';
export const REQUEST_GET_FEE_NOTES_TRANSACTION =
  'REQUEST_GET_FEE_NOTES_TRANSACTION';
export const REQUEST_ADD_QUOTATION_DOCUMENT = 'REQUEST_ADD_QUOTATION_DOCUMENT';
export const REQUEST_UPDATE_MISSION_TRANSACTION =
  'REQUEST_UPDATE_MISSION_TRANSACTION';
export const REQUEST_IMPORT_MISSION_EXPERTISE =
  'REQUEST_IMPORT_MISSION_EXPERTISE';

export const REQUEST_GET_JUDICIARY_EXPERT_REPORT =
  'REQUEST_GET_JUDICIARY_EXPERT_REPORT';

export const REQUEST_SET_JUDICIARY_EXPERT_REPORT =
  'REQUEST_SET_JUDICIARY_EXPERT_REPORT';

export const REQUEST_MAKE_DECISION_VICTIM_INFO =
  'REQUEST_MAKE_DECISION_VICTIM_INFO';

export const REQUEST_GET_TRANSACTION_INBOXE_AREA =
  'REQUEST_GET_TRANSACTION_INBOXE_AREA';
export const REQUEST_REJECT_TRANSACTION = 'REQUEST_REJECT_TRANSACTION';
export const REQUEST_SET_TRANSACTION_INBOXE_AREA =
  'REQUEST_SET_TRANSACTION_INBOXE_AREA';
export const REQUEST_ADD_TUTOR_INFO = 'REQUEST_ADD_TUTOR_INFO';

export const REQUEST_ADD_BENEFICIARY = 'REQUEST_ADD_BENEFICIARY';

export const TRANSACTIONS_TAB_LABELS = [
  'Information sur victime',
  'Prise de contact et Missionnement',
  'Expertise Medicale',
  'Offre et reglement',
];

export const TRANSACTION_STATUS = {
  TRANSACTION_DISCUSSION: 'Transaction Pourparler',
  TRANSACTION_CONTACT: 'Prise de contact',
  EXPERTISE: 'Expertise',
  UNSUCCESSFUL_TRANSACTION: 'Transaction non aboutie',
};
export const LIMIT_IPP = 20;

export const DECISION_DIALOG = {
  VALIDATION: 'decisionValidation',
  REFUSAL: 'decisionRefusal',
} as const;

export const TRANSACTION_STEPS = {
  VICTIM_INFO: 'VICTIM_INFO',
  VICTIM_INFO_THIRD_VALIDATION: 'VICTIM_INFO_THIRD_VALIDATION',
  CONTACT_VICTIM: 'CONTACT_VICTIM',
  EXPERTISE: 'EXPERTISE',
  FIRST_VALIDATION_REGULATION: 'FIRST_VALIDATION_REGULATION',
  SECOND_VALIDATION_REGULATION: 'SECOND_VALIDATION_REGULATION',
  THIRD_VALIDATION_REGULATION: 'THIRD_VALIDATION_REGULATION',
};
export const REGULATION_TRANSACTION_VALIDATION = [
  'FIRST_VALIDATION_REGULATION',
  'SECOND_VALIDATION_REGULATION',
  'THIRD_VALIDATION_REGULATION',
];

export const TRANSACTION_STATE = {
  BLOCKED: 'BLOCKED',
  DONE: 'DONE',
};
export const SECOND_VALIDATION_INBOXE_TITLE = '2ème validation';
export const THIRD_VALIDATION_INBOXE_TITLE = '3ème validation';
export const CONTACT_INBOXE_TITLE = 'Prise de contact / Missionnement';
export const EXPERTISE = 'Expertise';
export const OFFER_QUITTANCE_INBOXE_TITLE = 'Offre et Quittance';
export const PAYMENT_NATURE_TRANSACTION = '1';
export const CONST_TRANSACTION = 'TRANSACTION';
